import * as React from 'react';

import { PageHeaderContainer } from '../PageHeader';
import { AddQuestionFormContainer } from '../PostForm';
import { PageWithSidebar as Layout } from '../../components/Layouts';
import { SidebarWhatToAskAboutTip, SidebarFindRealtorTip } from '../../components/SidebarTips';

/**
 * Контейнер страницы добавления/редактирования вопроса
 */
export const AddQuestionPageContainer = () => {
  return (
    <Layout header={<PageHeaderContainer />} body={<AddQuestionFormContainer />}>
      <SidebarWhatToAskAboutTip />
      <SidebarFindRealtorTip />
    </Layout>
  );
};
